import Vue from 'vue'
import { getQueryString } from '../../../global/helpers';

const BASE_URL_FOLDERS = 'content-folders';
const BASE_URL_VIDEOS = 'videos';

export const ROOT_FOLDER_ID = 1;

const _showError = (error, defaultMessage) => {
  const serverMessage = error && error.response && error.response.data[0] && error.response.data[0].message;
  Vue.prototype.$swal.fire('Error', serverMessage ? serverMessage : defaultMessage);
}

const _getFoldersByParentId = (query) => {
  const base = `${BASE_URL_FOLDERS}/get-by-parent`;
  const url = [base, getQueryString(query)].join('?');
  return Vue.prototype.$http.get(url);
}

const _getVideosByParentId = (query) => {
  const base = `${BASE_URL_VIDEOS}/get-by-parent`;
  const url = [base, getQueryString(query)].join('?');

  return Vue.prototype.$http.get(url);
}

// Get folder
const getFolderById = (folderId) => {
  const url = `${BASE_URL_FOLDERS}/${folderId}`;

  return Vue.prototype.$http.get(url)
    .then(({ data }) => data)
    .catch((error) => _showError(error, 'Failed to get folder'));
};

// Create folder
const createFolder = ({ title, description, is_active, parent_id }) => {
  const data = { title, description, parent_id: parent_id ?? ROOT_FOLDER_ID, is_active };

  return Vue.prototype.$http.post(BASE_URL_FOLDERS, data)
    .catch((error) => _showError(error, 'Failed to create folder'));
};

// Update folder
const updateFolder = (folderId, { title, description, is_active }) => {
  const url = `${BASE_URL_FOLDERS}/${folderId}`;
  const data = { title, description, is_active };

  return Vue.prototype.$http.patch(url, data)
    .catch((error) => _showError(error, 'Failed to update folder'));
};

// Delete folder
const deleteFolder = (folderId) => {
  const url = `${BASE_URL_FOLDERS}/${folderId}`;

  return Vue.prototype.$http.delete(url)
    .catch((error) => _showError(error, 'Failed to delete folder. It must be empty'));
};

// Get folder children
const getFolderChildren = (parent_id) => {  
  return Promise.all([_getFoldersByParentId({ parent_id }), _getVideosByParentId({ parent_id })])
    .then(([folders, videos]) => ({ folders: folders.data, videos: videos.data }))
    .catch((error) => _showError(error, 'Failed to get folder children'));
}

// Has folders
const hasChildFolders = (parent_id) => {
  return _getFoldersByParentId({ parent_id }).then(({ data }) => data.length > 0)
}

// Change folder parent
const changeFolderParent = (folderId, parentId) => {
  const url = `${BASE_URL_FOLDERS}/move`;
  const data = { id: folderId, parent_id: parentId ?? ROOT_FOLDER_ID };

  return Vue.prototype.$http.post(url, data)
    .catch((error) => _showError(error, 'Failed to change folder parent'));
};

// Get video
const getVideoById = (videoId) => {
  const url = `${BASE_URL_VIDEOS}/${videoId}`;

  return Vue.prototype.$http.get(url)
    .then(({ data }) => data)
    .catch((error) => _showError(error, 'Failed to get video'));
};

// Create video
const createVideo = ({ title, content_folder_id, documents_ids = [], url, description, is_active }) => {
  const data = { title, content_folder_id, documents_ids, url, description, is_active };

  return Vue.prototype.$http.post(BASE_URL_VIDEOS, data)
    .catch((error) => _showError(error, 'Failed to create video'));
};

// Update video
const updateVideo = (videoId, { title, description, is_active, url, content_folder_id, documents_ids }) => {  
  const data = { title, description, is_active, url, content_folder_id, documents_ids };

  return Vue.prototype.$http.patch(`${BASE_URL_VIDEOS}/${videoId}`, data)
    .catch((error) => _showError(error, 'Failed to update video'));
};

// Delete video
const deleteVideo = (videoId) => {
  const url = `${BASE_URL_VIDEOS}/${videoId}`;

  return Vue.prototype.$http.delete(url)
    .catch((error) => _showError(error, 'Failed to delete video'));
};

// Change video parent
const changeVideoParent = (videoId, parentId) => {
  console.log('videoId', videoId, 'parentId', parentId)
  const url = `${BASE_URL_VIDEOS}/move`;
  const data = { id: videoId, folder_id: parentId ?? ROOT_FOLDER_ID };

  return Vue.prototype.$http.post(url, data)
    .catch((error) => _showError(error, 'Failed to change video parent'));
};

// Add video documents
const uploadVideoDocument = (document) => {
  const url = `${BASE_URL_VIDEOS}/document-upload`;
  const formData = new FormData();
  formData.append('document', document);

  return Vue.prototype.$http.post(url, formData)
    .catch((error) => _showError(error, 'Failed to upload document'));
}

const changeFolderOrder = (folder_id, order) => {
  const url = `${BASE_URL_FOLDERS}/reorder`;
  console.log('changeFolderOrder', order);

  return Vue.prototype.$http.post(url, { folder_id, order })
    .catch((error) => _showError(error, 'Failed to change folder order'));
}

const changeVideoOrder = (video_id, order) => {
  const url = `${BASE_URL_VIDEOS}/reorder`;
  console.log('changeVideoOrder', order);

  return Vue.prototype.$http.post(url, { video_id, order })
    .catch((error) => _showError(error, 'Failed to change video order'));
}

export {
  getFolderById,
  getFolderChildren,
  createFolder,
  updateFolder,
  deleteFolder,
  deleteVideo,
  getVideoById,
  updateVideo,
  createVideo,
  changeVideoParent,
  changeFolderParent,
  hasChildFolders,
  uploadVideoDocument,
  changeFolderOrder,
  changeVideoOrder,
}